<template>
  <div>
    <Button
      v-if="infoCtrl && isDetailLoad && editState"
      class="add-btn" style=" margin-left:310px ; float: left;"
      type="primary" @click="openEdit"
    >修改</Button>
    <Row v-if="!infoCtrl && isDetailLoad" class="case-form">
      <Form
        ref="formData" :model="formData"
        :disabled="caseState=='TN'" :rules="ruleValidate"
        :label-width="100"
      >
        <FormItem label="递交材料日期" prop="filingDate">
          <DatePicker
            transfer
            type="date"
            placeholder="请选择递交材料日期"
            style="width:100%"
            format="yyyy-MM-dd"
            :value="formData.filingDate"
            @on-change="getTime"
          />
        </FormItem>
        <FormItem label="递交方式" prop="filingWay">
          <Select
            v-model="formData.filingWay" transfer
            placeholder="请选择递交方式"
          >
            <Option
              v-for="item in deliverWayArr" :key="item.id"
              :value="item.value"
            >{{ item.nameZh }}</Option>
          </Select>
        </FormItem>
        <FormItem label="接受法院" prop="court">
          <!-- <span v-if="caseDetail.trialLevel === 'F'">{{formData.court}}</span> -->
          <mySelect
            ref="courtSelect"
            v-autoFill="autoFill.court"
            :path="'/report/courts'"
            :placeholder="'请选择管辖法院'"
            :placeholder-input="'请输入管辖法院'"
            :default-obj="defaultCourt"
            :key-name="'name'"
            :is-load="false"
            @getValue="getCourtId"
          />
        </FormItem>
        <Row class="detail-btn-box">
          <Button
            type="primary" style="margin-right:10px;"
            :disabled="isSubmit" @click="submitNew"
          >保存</Button>
          <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
        </Row>
      </Form>
    </Row>
    <Row v-if="infoCtrl&&isDetailLoad" class="detail-content">
      <Row><Col span="5" class="left-label">递交材料日期：</Col><Col span="16" class="right-content">{{ defaultData.filingDate }}</Col></Row>
      <Row><Col span="5" class="left-label">递交方式：</Col><Col span="16" class="right-content">{{ defaultData.filingWayName }}</Col></Row>
      <Row><Col span="5" class="left-label">接受法院：</Col><Col span="16" class="right-content">{{ defaultData.court }}</Col></Row>
    </Row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import getQccKeyData from '@/libs/qcc.js'
export default {
  components: {},
  props: ['processId', 'caseId', 'editState', 'caseState'],
  data () {
    return {
      isDetailLoad: false,
      infoCtrl: true,
      isSubmit: false,
      defaultData: '',
      deliverWayArr: [],
      formData: {
        filingDate: '',
        filingWay: '',
        court: '',
        courtId: ''
      },
      defaultCourt: {},
      ruleValidate: {
        filingDate: [{ required: true, message: '递交材料日期不能为空', trigger: 'blur' }],
        filingWay: [{ required: true, message: '递交方式不能为空', trigger: 'blur' }],
        court: [{ required: true, message: '递交法院不能为空', trigger: 'change' }]
      },
      caseDetail: '',
      hasDetail: false,
      autoFill: {
        court: false
      }
    }
  },
  computed: {
    ...mapGetters(['qccData']),
    qccWatch() {
      return {
        isDetailLoad: this.isDetailLoad,
        hasData: !!this.qccData.length
      }
    }
  },
  watch: {
    qccWatch: {
      handler: async function(value) {
        if (value.isDetailLoad && value.hasData && !this.infoCtrl) {
          const courtData = await getQccKeyData(this.qccData, 'court')
          if (courtData) {
            this.autoFill.court = true
            this.formData.court = this.courtData.court
            this.formData.courtId = this.courtData.id
            this.defaultCourt = {
              name: courtData.court,
              id: courtData.id
            }
          }
        }
      },
      deep: true
    }
  },
  created() {},
  beforeMount() {
    this.getDictionary()
    this.getDetail()
    this.getCaseDetail()
  },
  mounted() {},
  updated() {},
  methods: {
    // 获取案件详情(用于得知该案件是一审还是二审)
    getCaseDetail() {
      const url = '/business/case/' + this.caseId + '/lawyer'
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.caseDetail = res.data
          if (this.caseDetail.trialLevel === 'F') {
            this.getCourt()
          }
        }
      })
    },
    // 获取递交材料详情
    getDetail() {
      const url = '/business/case-filing?processId=' + this.processId
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.$emit('getAuditState', true)
          this.defaultData = res.data
          this.infoCtrl = true
          this.hasDetail = true
          this.giveDefaultData()
        } else {
          this.$emit('getAuditState', false)
          this.defaultData = ''
          this.infoCtrl = false
          this.isDetailLoad = true
        }
      })
    },
    // 获取受理
    getCourt() {
      const url = '/business/case/court/lawyer?caseId=' + this.caseId
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.formData.court = res.data
          const url = '/report/courts'
          const ajaxData = {
            keyword: this.formData.court
          }
          if (!this.infoCtrl && this.isDetailLoad) {
            this.$get(url, ajaxData).then(res => {
              if (res.code == 0 && res.data && res.data.records.length == 1) {
                this.$refs.courtSelect.chooseItem(res.data.records[0])
              }
            })
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getCourtId(data) {
      this.formData.court = data.name
      this.formData.courtId = data.id
      if (this.autoFill.court) {
        this.autoFill.court = false
      }
    },
    openEdit() {
      this.infoCtrl = false
    },
    getTime(value) {
      this.formData.filingDate = value
    },
    // 赋默认值
    giveDefaultData() {
      this.formData.filingDate = this.defaultData.filingDate
      this.formData.filingWay = this.defaultData.filingWay
      this.formData.court = this.defaultData.court
      this.formData.courtId = this.defaultData.courtId
      if (this.defaultData.court) {
        this.defaultCourt = {
          name: this.defaultData.court,
          id: this.defaultData.courtId
        }
      }
      this.isDetailLoad = true
    },
    submitNew() {
      let url = '/business/case-filing'
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      Object.assign(ajaxData, this.formData)
      if (this.defaultData) {
        url += `/${this.defaultData.id}`
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      }
    },
    // 数据字典
    async getDictionary() {
      this.deliverWayArr = await this.common.getDictionaryItems('filing_deliver_way')
    }
  }
}
</script>
<style scoped lang="scss">
@import "../caseCommon.scss";
.add-btn{
    margin-top:-64px;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/prosecute/submitMaterial.vue